var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex sm10 md10" },
    [
      _c(
        "FormFieldsContainer",
        [
          _c(
            "v-flex",
            { attrs: { sm10: "", md10: "", layout: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: _vm.formFields.tipoAlerta.label,
                          items: _vm.listaTiposAlerta,
                          "item-text": "nombre",
                          "item-value": "id"
                        },
                        model: {
                          value: _vm.formFields.tipoAlerta.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.tipoAlerta, "value", $$v)
                          },
                          expression: "formFields.tipoAlerta.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: _vm.formFields.flota.label,
                          items: _vm.listaFlotas,
                          "item-text": "nombre",
                          "item-value": "id"
                        },
                        on: {
                          change: function($event) {
                            return _vm.changeFlota($event)
                          }
                        },
                        model: {
                          value: _vm.formFields.flota.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.flota, "value", $$v)
                          },
                          expression: "formFields.flota.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: _vm.formFields.grupo.label,
                          items: _vm.listaGrupos,
                          "item-text": "nombre",
                          "item-value": "id"
                        },
                        on: {
                          change: function($event) {
                            return _vm.changeGrupo($event)
                          }
                        },
                        model: {
                          value: _vm.formFields.grupo.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.grupo, "value", $$v)
                          },
                          expression: "formFields.grupo.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: _vm.formFields.patente.label,
                          items: _vm.listaPatentes,
                          "item-text": "nombre",
                          "item-value": "id"
                        },
                        model: {
                          value: _vm.formFields.patente.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.patente, "value", $$v)
                          },
                          expression: "formFields.patente.value"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "" } },
                    [
                      _c(
                        "v-subheader",
                        {
                          staticClass:
                            "v-subheader-velocidad v-label v-label--active theme--light"
                        },
                        [_vm._v(_vm._s(_vm.formFields.velocidad.label))]
                      ),
                      _c("v-slider", {
                        attrs: {
                          "hide-details": "",
                          min: "0",
                          max: "200",
                          "thumb-label": "always",
                          "thumb-size": 24
                        },
                        model: {
                          value: _vm.formFields.velocidad.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.velocidad, "value", $$v)
                          },
                          expression: "formFields.velocidad.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "", hide: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: _vm.formFields.tipoFecha.label,
                          items: [
                            { id: "ingreso", nombre: "Ingreso" },
                            { id: "alerta", nombre: "Alerta" }
                          ],
                          "item-text": "nombre",
                          "item-value": "id"
                        },
                        model: {
                          value: _vm.formFields.tipoFecha.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.tipoFecha, "value", $$v)
                          },
                          expression: "formFields.tipoFecha.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "" } },
                    [
                      _c("DatePicker", {
                        attrs: {
                          label: _vm.formFields.fechaInicio.label,
                          "error-messages": _vm.errors.collect(
                            _vm.formFields.fechaInicio.id
                          ),
                          id: _vm.formFields.fechaInicio.id,
                          min: _vm.fechaMinima,
                          max: _vm.fechaMaximaInicio.format("YYYY-MM-DD")
                        },
                        model: {
                          value: _vm.formFields.fechaInicio.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.fechaInicio, "value", $$v)
                          },
                          expression: "formFields.fechaInicio.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "" } },
                    [
                      _c("TimePicker", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          label: _vm.formFields.horaInicio.label,
                          "data-vv-name": "horaInicioRequerida",
                          "error-messages": _vm.errors.collect(
                            "horaInicioRequerida"
                          ),
                          required: ""
                        },
                        model: {
                          value: _vm.formFields.horaInicio.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.horaInicio, "value", $$v)
                          },
                          expression: "formFields.horaInicio.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "" } },
                    [
                      _c("DatePicker", {
                        attrs: {
                          label: _vm.formFields.fechaFin.label,
                          "error-messages": _vm.errors.collect(
                            _vm.formFields.fechaFin.id
                          ),
                          id: _vm.formFields.fechaFin.id,
                          min: _vm.fechaMinima,
                          max: _vm.fechaMaximaInicio.format("YYYY-MM-DD")
                        },
                        model: {
                          value: _vm.formFields.fechaFin.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.fechaFin, "value", $$v)
                          },
                          expression: "formFields.fechaFin.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "" } },
                    [
                      _c("TimePicker", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          label: _vm.formFields.horaFin.label,
                          "data-vv-name": "horaFinRequerida",
                          "error-messages": _vm.errors.collect(
                            "horaFinRequerida"
                          ),
                          required: ""
                        },
                        model: {
                          value: _vm.formFields.horaFin.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.horaFin, "value", $$v)
                          },
                          expression: "formFields.horaFin.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: _vm.formFields.tipoEvidencia.label,
                          items: [
                            { id: "ambos", nombre: "Todos" },
                            { id: "jpg", nombre: "Foto" },
                            { id: "mp4", nombre: "Video" }
                          ],
                          "item-text": "nombre",
                          "item-value": "id"
                        },
                        model: {
                          value: _vm.formFields.tipoEvidencia.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.tipoEvidencia, "value", $$v)
                          },
                          expression: "formFields.tipoEvidencia.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "", hide: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.formFields.cantidadRegistros.label,
                          "single-line": "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.formFields.cantidadRegistros.value,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.formFields.cantidadRegistros,
                              "value",
                              $$v
                            )
                          },
                          expression: "formFields.cantidadRegistros.value"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("v-flex", { attrs: { sm1: "", md1: "" } }, [
            _c(
              "div",
              { staticClass: "text-sm-center" },
              [
                _c(
                  "v-btn",
                  {
                    attrs: { flat: "", icon: "", small: "" },
                    on: { click: _vm.handleBuscarClick }
                  },
                  [_c("v-icon", [_vm._v("search")])],
                  1
                ),
                _c(
                  "v-btn",
                  {
                    attrs: { flat: "", icon: "", small: "" },
                    on: { click: _vm.clearFilters }
                  },
                  [_c("v-icon", [_vm._v("clear")])],
                  1
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "clearfix", staticStyle: { width: "100%" } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }